import { call, fork, put, takeEvery, select } from 'redux-saga/effects';

import {
  FETCH_CASES,
  fetchCasesFail,
  fetchCasesSuccess,
  ASSIGN_CASE_TO_USER,
  assignCaseToUserSuccess,
  assignCaseToUserFail,
  ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE,
  reloadCases
} from '../../redux/actions/cm/caseList';
import { reloadCaseDetails } from '../../redux/actions/cm/caseDetails';

import { fetchCases } from '../../services/cm/cases';
import { assignCaseToUser } from '../../services/cm/cases';

function* fetchCaseListWorker({ filters, currentPage, pageSize }) {
  try {
    const { cases, total } = yield call(fetchCases, {
      filters,
      currentPage,
      pageSize
    });

    yield put(fetchCasesSuccess({ cases, total }));
  } catch (error) {
    yield put(fetchCasesFail(error.message));
  }
}

export function* watchFetchCaseList() {
  yield takeEvery(
    FETCH_CASES,
    function* ({ payload: { filters, currentPage, pageSize } }) {
      yield fork(fetchCaseListWorker, { filters, currentPage, pageSize });
    }
  );
}

function* assignCaseToUserWorker({ caseIds, user }) {
  try {
    yield call(assignCaseToUser, {
      caseIds,
      user
    });
    yield put(assignCaseToUserSuccess());
  } catch (error) {
    yield put(assignCaseToUserFail(error.message));
  }
}

export function* watchAssignCaseToUser() {
  yield takeEvery(
    ASSIGN_CASE_TO_USER,
    function* ({ payload: { caseIds, user } }) {
      yield fork(assignCaseToUserWorker, { caseIds, user });
    }
  );
}

function* fetchCaseDetails(selectedIds) {
  try {
    const getCaseDetails = (state) => state.cmCaseDetails.caseDetails;
    const caseDetails = yield select(getCaseDetails);
    const caseId = selectedIds?.find((id) => id === caseDetails?.acase?.id);
    if (caseId) yield put(reloadCaseDetails());
  } catch (error) {
    yield put(fetchCasesFail());
  }
}

export function* watchAssignCaseActionInfoModalClose() {
  yield takeEvery(
    ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE,
    function* ({ payload: selectedIds }) {
      yield fork(fetchCaseDetails, selectedIds);
    }
  );
}
